import React from 'react';
import { SvgLowFloorIcon } from './LowFloorIcon';

const WIDTH = 18; //全体の幅
const HEIGHT = 20; //全体の高さ
const TRIANGLE_HEIGHT = 5; //三角部分の高さ

export type DirectionType = 'top' | 'right' | 'bottom' | 'left';

type TransformsType = {
  [key in DirectionType]: {
    transform: string;
    x: number;
    y: number;
    x_dispNo: number;
    y_dispNo: number;
  };
};

// 方向ごとの回転と位置調整
const transforms: TransformsType = {
  top: {
    transform: ``,
    x: 0,
    y: 0,
    x_dispNo: 0,
    y_dispNo: 0
  },
  right: {
    transform: `translate(${HEIGHT}, ${0}) rotate(90)`,
    x: -1.1,
    y: -3.5,
    x_dispNo: -0.5,
    y_dispNo: -2
  },
  bottom: {
    transform: `translate(${WIDTH}, ${HEIGHT}) rotate(180)`,
    x: 0,
    y: -3.5,
    x_dispNo: 0,
    y_dispNo: -2.5
  },
  left: {
    transform: `translate(${0}, ${WIDTH}) rotate(270)`,
    x: 3,
    y: -3.2,
    x_dispNo: 2.5,
    y_dispNo: -2
  }
};
Object.freeze(transforms);

type Props = {
  x: number;
  y: number;
  direction: DirectionType;
  no: number;
  color: string;
  logo: boolean;
  dispNo: boolean;
  opacity: number;
};

const TrainOverview: React.FC<Props> = (props) => {
  const { x, y, direction, no, color, logo, dispNo, opacity } = props;

  return (
    <g transform={`translate(${x},${y})`}>
      <g transform={transforms[direction].transform}>
        <path
          fill={color}
          stroke='grey'
          strokeWidth={1}
          opacity={opacity}
          d={`M${WIDTH / 2} 0 L0 ${TRIANGLE_HEIGHT} v${
            HEIGHT - TRIANGLE_HEIGHT
          } h${WIDTH} v${-(HEIGHT - TRIANGLE_HEIGHT)} Z`}
        ></path>
      </g>
      <g>
        {dispNo ? (
          <g
            transform={`translate(${transforms[direction].x_dispNo} ${transforms[direction].y_dispNo})`}
          >
            <text
              x={WIDTH / 2}
              y={logo ? TRIANGLE_HEIGHT + 1.2 : HEIGHT / 2}
              fontSize={5}
              fontWeight='bold'
              fontFamily='sans-serif'
              textAnchor='middle'
              dominantBaseline='central'
              opacity={opacity}
            >
              {no}
            </text>
            {logo && (
              <g transform={`translate(3.9, 9) scale(0.065)`} opacity={opacity}>
                <SvgLowFloorIcon></SvgLowFloorIcon>
              </g>
            )}
          </g>
        ) : (
          <g
            transform={`translate(${transforms[direction].x} ${transforms[direction].y})`}
          >
            {logo && (
              <g transform={`translate(3, 6.2) scale(0.08)`} opacity={opacity}>
                <SvgLowFloorIcon></SvgLowFloorIcon>
              </g>
            )}
          </g>
        )}
      </g>
    </g>
  );
};

export default React.memo(TrainOverview);
